<template>
    <div class="bg_main">
        <v-container>
            <v-card class="card-orders-list">
                    <v-card-title class="pb-0">Mi perfil</v-card-title>
                    <v-card-subtitle class="grey--tex float-left my-0">Actualizar tu información personal</v-card-subtitle>
                    <v-divider class="my-10"></v-divider> 
                <v-card-text>
                    <v-form ref="formProfile" v-if="user != null" v-model="formValid">
                        <v-container>
                            <v-row class="mb-4">
                                <v-col cols="12" class="text-center">
                                    <v-avatar class="rounded perfil_letra_sub" size="180" color="accent">
                                        <img
                                            v-if="user.avatar_path != null &&  user.avatar != 'null' && !uploading"
                                            :src="user.avatar_path"
                                            :alt="user.usuario"
                                        >
                                        <span v-if="user.avatar_path == null &&  user.avatar == 'null' && !uploading">{{getProfileLetterName()}}</span>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="12" lg="4" offset-lg="4">
                                    <v-file-input
                                        outlined
                                        chips
                                        counter
                                        v-model="file"
                                        :loading="uploading"
                                        accept="image/*"
                                        label="Fotografía de perfil"
                                        placeholder="Actualizar fotografia de perfil"
                                        @change="onUploadFile"
                                        :error="hasError"
                                        :error-messages="errorMessage"
                                    >

                                    </v-file-input>
                                </v-col>
                            </v-row>

                            <v-divider class="divider_punteado my-6"></v-divider> 

                            <v-row>
                                <v-col cols="12" md="6" >
                                    <v-text-field
                                        outlined required
                                        v-model="user.usuario"
                                        label="* Nombre de usuario"
                                        disabled
                                        :rules="[formValidator.username.required, formValidator.username.min_max, formValidator.username.valid_char]"
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined required
                                        v-model="user.email"
                                        label="* Correo electrónico"
                                        type="email"
                                        placeholder="Proporciona un correo electrónico válido."
                                        hint="¡Asegúrate de escribir bien tu correo!."
                                        title="El correo que proporciones será el medio por el cual nos estaremos comunicando contigo, en caso de ser necesario. Por tal razón, asegúrate de que esté correctamente escrito."
                                        :rules="[formValidator.email.required, formValidator.email.valid_email]"
                                    />
                                </v-col>
                                <template v-if="user.tipo_persona === 'fisica'">
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            outlined required
                                            v-model="user.nombres"
                                            label="* Nombre(s)"
                                            :disabled="true"
                                            :rules="[formValidator.name.required]"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            outlined required
                                            v-model="user.apellido_paterno"
                                            label="* Apellido paterno"
                                            :disabled="true"
                                            :rules="[formValidator.lastname_pat.required]"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            outlined required
                                            v-model="user.apellido_materno"
                                            label="Apellido materno"
                                            :disabled="true"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            outlined required
                                            v-model="user.curp"
                                            label="* CURP"
                                            :disabled="true"
                                            :rules="[formValidator.curp.required, formValidator.curp.ws_validate]"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            outlined
                                            v-model="user.rfc"
                                            label="RFC"
                                            :rules="[formValidator.rfc.physic_pattern_valid]"
                                        />
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            outlined required
                                            v-model="user.nombres"
                                            label="Nombre de la razón social"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            required outlined
                                            v-model="user.rfc"
                                            label="* RFC"
                                            disabled
                                        />
                                    </v-col>
                                </template>

    <!--                            <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined required
                                        v-model="user.password"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="showPassword? 'text' : 'password'"
                                        @click:append="showPassword = !showPassword"
                                        label="* Contraseña"
                                        placeholder="Asegurate de escribir tu actual contraseña para aplicar los cambios"
                                        :rules="[formValidator.password.required]"
                                    />
                                </v-col>-->
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <v-btn color="error" class="mx-2" link :to="{name: 'home'}" large>
                                        Cancelar
                                    </v-btn>
                                    <v-btn color="primary" class="mx-2" large @click="saveProfile()">
                                        Guardar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import * as Storage from '@/core/storage'
    import Constants from "@/core/constants";
    import registerFormValidator from "@/form/register.form.validator";
    import {Auth} from "../api";

export default {
    name: "UserProfile",

    data() {
        return {
            formValid: false,
            user: null,
            showPassword: false,
            formValidator: registerFormValidator,

            file: null,
            uploading: false,
            hasError: false,
            errorMessage: ''
        }
    },

    computed: {
        ...mapState({accountStore: state => state.account})
    },

    mounted() {
        this.user = JSON.parse(Storage.getItem(Constants.KEY_USER))
        delete this.user.access_token
    },

    created() {
        this.$gtag.event('perfil_usuario', { method: 'Google' }) // Google Analytics
    },

    methods: {
        ...mapActions('account', ['postUserProfile']),

        saveProfile(){
            this.$refs.formProfile.validate();

            if (this.formValid){
                Object.keys(this.user).forEach(key => {
                    if (this.user[key] === null){
                        delete this.user[key]
                    }
                })

                this.user['url_redirect'] = window.location.origin
                this.postUserProfile(this.user)
            }
        },

        getUserAvatar(){
            // console.log(process.env.VUE_APP_BASE_URL)
            return process.env.VUE_APP_BASE_URL+this.user.avatar
        },

        getProfileLetterName(){
            if (this.user){
                var letra = `${this.user.nombres}`;
                return letra.substring(0,1);
            }

            return ''
        },

        onUploadFile(file){
            if (file != null){
                this.uploading = true

                Auth.updateProfileAvatar({qqfile: file})
                    .then(result => {
                        this.uploading = false
                        this.user.avatar = result.file_name
                        this.user.avatar_path = result.file_path
                    })
                    .catch(error => {
                        this.uploading = false
                        this.hasError = true
                        this.errorMessage = error.message
                    })

            }else {
                this.user.avatar = null
                this.user.avatar_path = null
                this.hasError = false
                this.errorMessage = null
            }
        },
    },
}
</script>

<style scoped>


    .card-orders-list {
        min-height: 85vh;
    }
</style>